export const WindowSizeBreakpoints = {
    small: 576,
    medium: 768,
    large: 992,
    extraLarge: 1200,
};

